module.exports = __webpack_public_path__ + "img/dab_sloneczny_brzeg.a01cb713.jpg";